import styles from "./Contact.module.css";

import { useState } from "react";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (name === "" || email === "" || message === "") {
      console.log("preencha todos os campos!");
      return;
    }

    const templateParams = {
      from_name: name,
      email: email,
      message: message,
    };

    emailjs
      .send(
        "service_m8nn27l",
        "template_73m0rkt",
        templateParams,
        "7osgj0ImkZMfwrI_m"
      )
      .then(
        (result) => {
          console.log(result.text);
          setName("");
          setEmail("");
          setMessage("");
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <section className={`${styles.contact} section`} id="contact">
      <h2 className="section__title">Contato</h2>
      <p className="section__subtitle">Envie uma mensagem</p>
      <form onSubmit={handleSubmit}>
        <h2>Envie um e-mail</h2>
        <input
          type="text"
          placeholder="Digite seu nome"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
          }}
        />
        <input
          type="email"
          placeholder="Digite o seu e-mail"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
        <textarea
          name="message"
          placeholder="Insira sua mensagem"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows="5"
        ></textarea>
        <button type="submit" className="button button-flex">
          Enviar <i className={`uil uil-message`}></i>
        </button>
      </form>
    </section>
  );
};

export default Contact;
